import React from "react";
import LinkIcon from "app/assets/icons/LinkIcon";

interface ConnectBankBoxProps {
  onClick: () => void;
  className?: string;
}

const ConnectBankBox: React.FC<ConnectBankBoxProps> = ({
  onClick,
  className = "",
}) => {
  return (
    <div className={`w-full ${className} `}>
      <div className="bg-[#EAECF0] py-5 px-4 w-full text-center rounded-[20px] h-[340px]  relative xl:h-[340px] flex flex-col items-center">
        <div className="text-center  mb-4">
          <LinkIcon className="mx-auto" />
        </div>
        <h6 className="text-[14px] font-normal  text-center text-darkgrey font-Mulish mb-4 w-full ">
          Connect your bank account
        </h6>
        <p className="text-[12px] font-normal  text-center text-[#313131] font-Mulish w-full sm:w-[90%] mb-4">
          Link your bank account securely using Illion (Open Data Service). This
          allows us to verify your financial details instantly.
        </p>
        <p className="text-[12px] font-normal  text-center text-[#585C7B] font-Mulish w-full mb-4">
          Your data is read-only, encrypted, and never shared without your
          consent.  Secure and private 
        </p>
        <p className="text-[12px] font-normal  text-center text-[#EA4335] font-Mulish w-full sm:w-[90%] 2xl:mb-4">
          After connecting, return to this page to continue your application
        </p>
        <div className="mt-6">
          <button
            type="button"
            className="absolute md:bottom-5   translate-x-[-50%] border border-solid bg-primary border-primary text-sm font-normal text-[#fff]  font-Mulish rounded-full px-4 py-2"
            onClick={onClick}
          >
            Connect instantly
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConnectBankBox;
